import React, { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { SearchCalendar } from './SearchCalendar'
import { searchData, PlanType } from './type'
import { PlanList } from './PlanList'

type PlanListType = PlanType[]

export const LpAvailability = () => {
  const [planList, setPlanList] = useState<PlanListType>([])
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const query = new URLSearchParams(location.search)
      const queryParams = Object.fromEntries(query.entries())

      const params = {
        ...searchData,
        ...queryParams,
        start_date: queryParams.start_date || '',
      }
      Object.assign(searchData, { ...params })

      const { data } = await axios.get(location?.pathname, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        params,
      })

      setPlanList(data.plans)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }, [location?.pathname])

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    axios.get(location.pathname + '/header_price' + location.search).then((res) => {
      if (res.data) {
        const element = document.getElementsByClassName('price-info-block')[0] as HTMLElement
        element.outerHTML = res.data
      }
    })
  }, [location.search])

  return (
    <div className="flex flex-col-reverse md:flex-row content-new">
      <div className="info-block conLeft w-full md:w-[65%]">
        <div id="availability">
          <p className="availability-title text-left font-a1 font-size-20 md:font-size-28">空き日程</p>
          {loading ? (
            <div className="flex flex-col">
              <PlanSkeleton />
              <PlanSkeleton />
            </div>
          ) : (
            <PlanList planList={planList} />
          )}
        </div>
      </div>
      <div className="conRight w-full md:w-[35%]">
        <div className="calendar-info-block h-fit bg-white w-full md:relative md:sticky md:mt-0">
          <div className="calendar-info-content">
            <SearchCalendar onChange={fetchData} />
          </div>
        </div>
      </div>
    </div>
  )
}

const PlanSkeleton = () => {
  return (
    <>
      <div className="mb-2 animate-pulse-card">
        <div className="h-4 w-32 bg-gray-200 rounded mb-4"></div>
        <div className="flex gap-5 items-center justify-start">
          <div className="w-[120px] h-[80px] bg-gray-200 rounded"></div>
          <div className="flex-1">
            <div className="h-4 w-40 bg-gray-200 rounded mb-2"></div>
            <div className="h-3 w-64 bg-gray-200 rounded mb-3"></div>
            <div className="flex gap-2 mt-2">
              <div className="h-6 w-24 bg-gray-200 rounded"></div>
              <div className="h-6 w-20 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
        <div className="flex gap-2 overflow-auto mt-5 mb-6">
          {[...Array(6)].map((_, index) => (
            <div
              key={index}
              className="flex flex-col gap-2 items-center justify-between p-3 text-center w-18 h-24 bg-gray-200 rounded-md"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="h-3 w-10 bg-gray-300 rounded"></div>
              <div className="h-5 w-5 bg-gray-300 rounded-full"></div>
              <div className="h-3 w-12 bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
